import { LocaleSettingsContextProvider } from 'modules/campaigns/lib/contexts/LocaleSettingsContext';
import { LocalesQueryContextProvider } from 'modules/campaigns/lib/contexts/LocalesQueryContext';
import { QueryParamContextProvider } from 'modules/templateEditor/context/QueryParamContextProvider';
import { DevicePreviewContent } from './DevicePreviewContent';
import { DevicePreviewContextProvider } from '../context/DevicePreviewContextProvider';

export const DevicePreviewPage = () => {
  return (
    <QueryParamContextProvider>
      <LocaleSettingsContextProvider>
        <LocalesQueryContextProvider>
          <DevicePreviewContextProvider>
            <DevicePreviewContent />
          </DevicePreviewContextProvider>
        </LocalesQueryContextProvider>
      </LocaleSettingsContextProvider>
    </QueryParamContextProvider>
  );
};
